import * as React from "react";
import { browserHistory } from "react-router";
import { useStores } from "#stores";

/**
 * Guards Coala/delivery-only screens. A marketplace-only place
 * (marketplaceIntegration ON, delivery OFF) has no provisioned Coala/delivery store,
 * so these screens would error or render empty. Such places are redirected to the
 * delivery settings page; the wrapped component only mounts when `delivery` is enabled.
 */
export function withDeliveryFeatureGuard<P extends { params?: { placeId?: string } }>(
	Component: React.ComponentType<P>,
): React.FC<P> {
	return function DeliveryFeatureGuarded(props: P) {
		const { placeStore } = useStores();
		const hasDelivery = placeStore.hasFeature("delivery");
		const placeId = props.params?.placeId;

		React.useEffect(() => {
			if (!hasDelivery && placeId) {
				browserHistory.push(`/place/${placeId}/delivery/settings`);
			}
		}, [hasDelivery, placeId]);

		if (!hasDelivery) {
			return null;
		}

		return <Component {...props} />;
	};
}
